import posthog from 'posthog-js';
import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import { withAuthenticationRequired } from '@auth0/auth0-react';
import { useCurrentUserQuery } from '@dashboard/generated/wp/authentication';

const WpRequireAuthenticationPageLayout = withAuthenticationRequired(() => {
  const { loading, data } = useCurrentUserQuery();
  const userId = data?.currentUser?.id;
  const userEmailAddress = data?.currentUser?.emailAddress;

  useEffect(() => {
    if (!userId || !userEmailAddress) {
      return;
    }
    posthog.identify(userId, { emailAddress: userEmailAddress });
  }, [userId, userEmailAddress]);

  if (loading) {
    return null;
  }
  return <Outlet />;
});

export default WpRequireAuthenticationPageLayout;
